// extracted by mini-css-extract-plugin
export default {"leftbarWidthInt":"54","leftbarWidth":"54px","appbarHeightInt":"54","appbarHeight":"54px","date":"FixedDate__date___a41jb"};